import type { TranslationMessages } from '../types';

export const wizards: TranslationMessages = {
      manager: {
        title: 'Hướng Dẫn Tính Năng',
        description: 'Khám phá và tìm hiểu về các tính năng trong NEKO POS',
        searchPlaceholder: 'Tìm kiếm tính năng...',
        resetWizard: 'Đặt Lại Hướng Dẫn',
        resetAll: 'Đặt Lại Tất Cả Hướng Dẫn',
      },
      modernOrderList: {
        welcome: {
          title: 'Chào Mừng Đến Với Danh Sách Đơn Hàng Hiện Đại',
          description: 'Giao diện quản lý đơn hàng mạnh mẽ và đáp ứng',
          info: 'Đây là giao diện danh sách đơn hàng mới và được cải thiện',
          content:
            'Danh sách đơn hàng hiện đại cung cấp khả năng tìm kiếm, lọc và quản lý nâng cao.',
        },
        search: {
          title: 'Tìm Kiếm Nâng Cao',
          description:
            'Tìm kiếm đơn hàng theo khách hàng, sản phẩm hoặc mã tham chiếu',
          highlight: 'Tìm Kiếm Mạnh Mẽ',
          details: 'Tìm kiếm trên nhiều trường đồng thời',
          feature1: 'Tìm Kiếm Đa Trường',
          feature1Desc:
            'Tìm kiếm theo tên khách hàng, tên sản phẩm hoặc mã đơn hàng',
          feature2: 'Kết Quả Thời Gian Thực',
          feature2Desc: 'Xem kết quả cập nhật khi bạn nhập',
        },
        responsive: {
          title: 'Thiết Kế Đáp Ứng',
          description: 'Hoạt động hoàn hảo trên máy tính và điện thoại',
          desktop: 'Chế Độ Máy Tính',
          desktopDesc: 'Chế độ xem bảng đầy đủ tính năng với tất cả các cột',
          mobile: 'Chế Độ Điện Thoại',
          mobileDesc: 'Bố cục thẻ được tối ưu hóa cho màn hình nhỏ',
          tip: 'Giao diện tự động điều chỉnh theo kích thước màn hình của bạn',
        },
        bulkRelease: {
          title: 'Giải Phóng Hàng Loạt',
          description: 'Giải phóng nhiều bàn cùng một lúc',
          highlight: 'Hành Động Hàng Loạt',
          details: 'Chọn nhiều đơn hàng và giải phóng bàn cùng nhau',
          feature1: 'Chọn Nhiều',
          feature1Desc: 'Chọn nhiều đơn hàng bằng hộp kiểm',
          feature2: 'Giải Phóng Một Lần Nhấp',
          feature2Desc: 'Giải phóng tất cả các bàn đã chọn bằng một hành động',
        },
        productNames: {
          title: 'Tên Sản Phẩm',
          description: 'Xem tên sản phẩm thay vì ID',
          highlight: 'Hiển Thị Sản Phẩm',
          details: 'Tên sản phẩm được tự động tải và hiển thị',
          tip: 'Tên sản phẩm được lưu trong bộ nhớ cache để tải nhanh hơn',
        },
        currencySettings: {
          title: 'Cài Đặt Tiền Tệ',
          description: 'Cấu hình hiển thị và định dạng tiền tệ',
          highlight: 'Cấu Hình Tiền Tệ',
          details: 'Đặt tiền tệ và tùy chọn định dạng ưa thích của bạn',
          feature1: 'Chọn Tiền Tệ',
          feature1Desc: 'Chọn từ các loại tiền tệ có sẵn',
          feature2: 'Tùy Chọn Định Dạng',
          feature2Desc: 'Tùy chỉnh cách hiển thị số tiền',
          action: 'Cấu Hình Tiền Tệ',
        },
        versionSwitcher: {
          title: 'Chuyển Đổi Phiên Bản',
          description: 'Chuyển đổi giữa giao diện hiện đại và cổ điển',
          highlight: 'Tùy Chọn Giao Diện',
          details:
            'Chọn giữa giao diện hiện đại và giao diện React Admin cổ điển',
          tip: 'Bạn có thể chuyển về giao diện cổ điển bất cứ lúc nào',
        },
        keywords: 'đơn hàng, danh sách, tìm kiếm, lọc, bảng, giải phóng',
      },
      products: {
        welcome: {
          title: 'Chào Mừng Đến Với Sản Phẩm',
          description: 'Quản lý danh mục sản phẩm của bạn',
          info: 'Tạo và quản lý sản phẩm của bạn',
          content: 'Thêm sản phẩm, đặt giá và tổ chức theo danh mục',
        },
        manage: {
          title: 'Quản Lý Sản Phẩm',
          description: 'Tạo và chỉnh sửa sản phẩm',
          highlight: 'Quản Lý Sản Phẩm',
          details: 'Đầy đủ các thao tác CRUD cho sản phẩm',
          step1: 'Tạo sản phẩm với tên, giá và mô tả',
          step2: 'Tổ chức sản phẩm vào danh mục',
          action: 'Đi Đến Sản Phẩm',
        },
        settings: {
          title: 'Cài Đặt Sản Phẩm',
          description: 'Cấu hình cài đặt liên quan đến sản phẩm',
          highlight: 'Cài Đặt',
          details: 'Tùy chỉnh hiển thị và hành vi sản phẩm',
          tip: 'Cài đặt ảnh hưởng đến cách sản phẩm được hiển thị trong toàn bộ hệ thống',
        },
        keywords: 'sản phẩm, danh mục, giá',
      },
    };
